export default {
  en: {
    notification: {
      statustext: 'notification',
      dismiss: 'Click to dismiss',
      Warning: 'Warning',
      Success: 'Success',
      Error: 'Error',
      Info: 'Info',

      confirmaction: {
        text: 'Are you sure you want to do this?',
        button: 'Confirm',
      }
    }
  },
  de: {
    notification: {
      statustext: 'Benachrichtigung',
      dismiss: 'Zum Schließen anklicken',
      Warning: 'Warnung',
      Success: 'Erfolg',
      Error: 'Fehler',
      Info: 'Info',

      confirmaction: {
        text: 'Sind Sie sicher, dass Sie dies tun möchten?',
        button: 'Bestätigen',
      }
    }
  },
  es: {
    notification: {
      statustext: 'notificación',
      dismiss: 'Haga clic para descartar',
      Warning: 'Advertencia',
      Success: 'Éxito',
      Error: 'Error',
      Info: 'Información',

      confirmaction: {
        text: '¿Estás seguro de que quieres hacer esto?',
        button: 'Confirmar',
      }
    }
  },
  uk: {
    notification: {
      statustext: 'сповіщення',
      dismiss: 'Натисніть, щоб закрити',
      Warning: 'Попередження',
      Success: 'Успіх',
      Error: 'Помилка',
      Info: 'Інформація',

      confirmaction: {
        text: 'Ви впевнені, що хочете це зробити?',
        button: 'Підтвердити',
      }
    }
  },
}
